import { useState } from "react"

export const PersonalizationState = () => {
    const [startHere, setStartHere] = useState({show:true, modal: false, tasks:[]});
    const [openWelcome, setOpenWelcome] = useState(false);
    const [openIntro, setOpenIntro] = useState({open:false, name:null});
    const [setup, setSetup] = useState({
        home_tour: {
            stat: false, 
            drawer: false, 
        }
    });
    const [walkthrough, setWalkthrough] = useState({
        superadmin: {
            dashboard:false,
            trainings:false,
            speaker:false,
            provider:false,
            reports:false,
        },
        regularuser: {
            dashboard:false,
            trainings:false,
            certificates:false,
            myprofessional:false,
        },
    });

    const [stepIndex, setStepIndex] = useState(0);

    const [isSteps, setIsSteps] = useState(
        [
            {selector:'.first-step' , name:'Dashboard', desc:'Your central hub for an overview of transactions and key activities.', content:[]},
            {selector:'.second-step' , name:'Trainings', desc:'Set up and organize topics, video lessons, and exams to create a complete learning experience.', content:[]},
            {selector:'.third-step' , name:'Speaker', desc:'Set up and manage speakers by defining whether they are internal or external.', content:[]},
            {selector:'.fourth-step' , name:'Provider', desc:'Manage and maintain provider information to ensure accurate and up-to-date records.', content:[]},
            {selector:'.fifth-step' , name:'Reports', desc:'View and generate reports to analyze system data and performance.', content:[]},
            {selector:'.sixth-step' , name:'Tool Categories', desc:'Tools you need for your career growth.', content:[]},
            {selector:'.seventh-step' , name:'Help', desc:'Access FAQs and take a guided tour to better understand and navigate the system.', content:[]},

            {selector:'.eighth-step' , name:'Support', desc:'Access support resources, submit tickets, and manage user assistance.', content:[]},
            {selector:'.ninth-step' , name:'Get App for Desktop', desc:'Download the desktop application for easier and faster system access.', content:[]},
            {selector:'.tenth-step' , name:'General Maintenance', desc:'Manage system maintenance settings, updates, and configurations.', content:[]},
            {selector:'.eleventh-step' , name:'My Tools', desc:'Access and manage the tools available for your account.', content:[]},
            // {selector:'.tenth-step' , name:'Switch to Personal', desc:'Switch to Personal to grow your career.', content:[]},
            // {selector:'.ninth-step' , name:'Switch to Business', desc:'Switch to Business to grow your business.', content:[]},
        ]
    );

    return {
        startHere: {data: startHere, set: setStartHere},
        walkthrough: {data: walkthrough, set: setWalkthrough},
        openWelcome: {data: openWelcome, set: setOpenWelcome},
        setup: {data: setup, set: setSetup},
        isSteps:{ data: isSteps, set: setIsSteps},
        stepIndex:{ data: stepIndex, set: setStepIndex},
        openIntro:{ data: openIntro, set: setOpenIntro},
    }
}

